import {
  ChangeDetectionStrategy,
  Component,
  Input, OnChanges, OnInit, SimpleChanges
} from "@angular/core";
import {LocationType} from "../../../../commons/types/location.type";
import {OrderModel} from "../../../models/order.model";
import * as _ from "lodash";

require('./oms-order-fulfillment-line-notes.scss');
@Component({
  standalone: false,
  selector: 'app-oms-orders-fulfillment-line-notes',
  templateUrl: './oms-order-fulfillment-line-notes.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OmsOrderFulfillmentLineNotesComponent implements OnInit, OnChanges {

  @Input() order: OrderModel;

  public notes: string[];

  public locationTypes: typeof LocationType = LocationType;

  constructor() {
  }

  ngOnInit() {
    this._initNotes();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.order && !changes.order.isFirstChange()) {
      this._initNotes();
    }
  }

  private _initNotes() {
    this.notes = _.map(_.get(this.order, 'internalNotes', []), (externalNote) => {
      return externalNote.text;
    });
    _.forEach(this.order.fulfillmentLines, l => {
      if (l.pickupTask && l.pickupTask.notes) {
        this.notes.push(l.pickupTask.notes);
      }
      if (l.destinationTask && l.destinationTask.notes) {
        this.notes.push(l.destinationTask.notes);
      }
    });
  }

}
